import { preloadFSxpertArtifacts, preloadFSxpertModule } from './utils/preloadFSxpert';

preloadFSxpertModule();
preloadFSxpertArtifacts();
